import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Ids, setFormOpen } from "../reducers/rhapsody";
import { useContractor } from "../redux/contractor/contractorHooks";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  LinearProgress,
  Typography,
} from "@mui/joy";
import { Cover } from "../hooks/cover/cover";
import { useContractors } from "../redux/contractor/contractorHooks";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { GigsDatagrid } from "../hooks/gigsDatagrid/gigsDatagrid";
import { RouterConfig } from "../hooks/config/routerConfig";
import { compatibleSources } from "../global";
import Calendar from "../hooks/calendar/calendar";
import { useDispatch } from "react-redux";
import { useGigs } from "../redux/gig/gigHooks";
import { ContractorGeneral } from "../hooks/contractorGeneral/contractorGeneral";
import { proEnabled } from "../constants";

export function useContractorIDs(): Ids {
  const [searchParams] = useSearchParams();
  const sourceID = parseInt(searchParams.get("sourceID"));
  const sourceRecordID = parseInt(searchParams.get("sourceRecordID"));
  const id = parseInt(searchParams.get("id"));
  return { id, sourceID, sourceRecordID };
}

/**
 *
 * @returns {ReactElement} ContractorPage page
 */
export function ContractorPage() {
  const dispatch = useDispatch();
  const contractorIDs = useContractorIDs();
  const { contractor, isLoading } = useContractor(contractorIDs);
  const [currentTab, setCurrentTab] = useState(0);
  const navigate = useNavigate();
  const { contractors } = useContractors();
  const { gigs } = useGigs();

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        justifyContent: isLoading ? "center" : undefined,
        alignItems: isLoading ? "center" : undefined,
        // maxWidth: 1200,
        // background: "red",
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        p: 2,
      }}
    >
      {isLoading ? (
        <CircularProgress />
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "start" }}>
            <Button
              color="neutral"
              variant="soft"
              onClick={() => navigate(RouterConfig.contractors)}
              startDecorator={<i className="fa-solid fa-chevron-left"></i>}
              size="sm"
            >
              Back
            </Button>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box>
                <Typography level="h5" sx={{ fontWeight: 600 }}>
                  {contractor.name}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Tabs
              onChange={(e, v) => setCurrentTab(v)}
              value={currentTab}
              variant="scrollable"
              sx={{ width: "100%" }}
            >
              <Tab sx={{ textTransform: "none" }} value={0} label="Services" />
              <Tab sx={{ textTransform: "none" }} value={1} label="Calendar" />
              <Tab sx={{ textTransform: "none" }} value={2} label="General" />
            </Tabs>
            <Divider />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              width: "calc(100vw - 32px)",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {currentTab === 0 ? (
              <>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  {proEnabled ? (
                    <Button
                      onClick={() => {
                        dispatch(setFormOpen({ isOpen: true, formID: "gig" }));
                      }}
                      size="sm"
                      color="info"
                    >
                      + New Service
                    </Button>
                  ) : (
                    []
                  )}
                </Box>

                <GigsDatagrid contractorID={contractor.sourceRecordID} />
              </>
            ) : (
              []
            )}
            {currentTab === 1 ? (
              <Calendar
                contractorID={contractor.sourceRecordID}
                disableCreate={contractor.sourceID !== 420}
              />
            ) : (
              []
            )}
            {currentTab === 2 ? <ContractorGeneral /> : []}
          </Box>
        </Box>
      )}
    </Box>
  );
}
